import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Card, Form, Button, Row, Col } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "../../components/css/Login.css";
import { useAuth } from '../../services/hooks/useAuth';

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showProjectSelection, setShowProjectSelection] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
    
  // Usar los hooks para autenticación y proyectos
  const { login, getUsuariosProyectos } = useAuth();

  // Sesión activa + ruta Hotelería desde Corporativo → pedir proyecto de campamento
  useEffect(() => {
    if (!location.state?.requireCampamentoProject) return;

    const token = localStorage.getItem("token");
    if (!token) return;

    toast.info(
      "Hotelería requiere un proyecto de campamento. Seleccione un proyecto (no Corporativo).",
      { position: "bottom-right", autoClose: 6000 }
    );

    try {
      const stored = JSON.parse(localStorage.getItem("proyectosUser") || "[]");
      if (Array.isArray(stored) && stored.length > 0) {
        setProjects(stored);
        setShowProjectSelection(true);
      }
    } catch {
      /* ignore */
    }
  }, [location.state]);
   
  // Función para manejar el login inicial (solo usuario y contraseña)
  const handleLogin = async (event) => {
    event.preventDefault();
 
    try {
      const response = await login(user, password);
      
      console.log(' *** response *** ', response);
      // Si login retorna null (error), no hacer nada más
      if (!response) {
        return;
      }
      
      console.log(' *** response.status *** ', response.status);

      if (response.status === 200 && response.data) {
        console.log('EEE');
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        // Obtener proyectos del usuario autenticado
        console.log('Usuario logueado:', response.data.user);
        
        const responseClients = await getUsuariosProyectos(
          response.data.user.id
        );
        
        console.log('Clientes/Proyectos del usuario:', responseClients);

        // Procesar proyectos del usuario
        const userProjects = responseClients && responseClients.length > 0
          ? responseClients
              .map(client => ({
                id: client.id,
                nombre: client.nombre || `Proyecto ${client.id}`
              }))
              .filter((proyecto, index, self) => 
                index === self.findIndex(p => p.id === proyecto.id)
              )
          : [];

        console.log('Proyectos procesados:', userProjects);

        if (userProjects.length > 0) {
          localStorage.setItem("clients", JSON.stringify(responseClients));
          localStorage.setItem(
            "proyectosUser",
            JSON.stringify(userProjects)
          );
        }

        setProjects(userProjects);
        
        // Si el usuario NO tiene proyectos asignados, solo tiene "Corporativo" disponible
        // Seleccionarlo automáticamente y redirigir
        if (userProjects.length === 0) {
          console.log('Usuario sin proyectos asignados, ingresando automáticamente a Corporativo');
          
          const corporativoProject = {
            id: -1,
            nombre: "Corporativo",
            proyecto_nombre: "Corporativo",
            tipo: "corporativo"
          };

          localStorage.setItem("selectedProject", JSON.stringify(corporativoProject));

          toast.success("Accediendo a Corporativo...", {
            position: "bottom-right",
            autoClose: 1500,
          });

          // Redirigir directamente a resumen corporativo
          setTimeout(() => {
            navigate("/resumen-corporativo");
          }, 1500);
          return;
        }
        
        // Si tiene proyectos, mostrar pantalla de selección
        console.log('Usuario con proyectos asignados, mostrando pantalla de selección');
        setShowProjectSelection(true);
      }
    } catch (error) {
      // Manejar el error y mostrar un mensaje claro
      console.error('Error en login:', error);
      console.error('Error response data:', error.response?.data);
      console.error('Error response status:', error.response?.status);
      
      // Determinar el mensaje de error apropiado
      let errorMessage = 'Error al iniciar sesión';
      
      if (error.response?.status === 400 || error.response?.status === 401) {
        // Error de credenciales inválidas (400 para errores de negocio, 401 para problemas de autenticación)
        // El backend devuelve el mensaje en 'message' y 'error', no en 'detail'
        errorMessage = error.response?.data?.detail || 
                      error.response?.data?.message || 
                      error.response?.data?.error ||
                      'Credenciales inválidas. Por favor, verifique su usuario y contraseña.';
        console.log('Mensaje de error específico:', errorMessage);
      } else if (error.response?.status === 500) {
        // Error del servidor
        errorMessage = 'Error del servidor. Por favor, intente nuevamente más tarde.';
      } else if (error.message) {
        // Otro error con mensaje
        errorMessage = error.message;
      }
      
      // Mostrar toast con el mensaje de error
      toast.error(errorMessage, {
        position: "bottom-right",
        autoClose: 4000,
      });
      
      // Limpiar campos de contraseña por seguridad
      setPassword('');
    }
  };

  // Función para manejar la selección de proyecto
  const handleProjectSelection = async (event) => {
    event.preventDefault();

    // Verificar si es corporativo
    if (selectedProject === "-1") {
      const corporativoProject = {
        id: -1,
        nombre: "Corporativo",
        proyecto_nombre: "Corporativo",
        tipo: "corporativo"
      };

      localStorage.setItem("selectedProject", JSON.stringify(corporativoProject));

      toast.success("Accediendo a Corporativo, redireccionando...", {
        position: "bottom-right",
        autoClose: 1000,
      });

      // Redirigir a resumen corporativo
      setTimeout(() => {
        navigate("/resumen-corporativo");
      }, 1000);
      return;
    }

    const selectedProjectData = projects.find(
      (proyecto) => proyecto.id === parseInt(selectedProject)
    );

    if (selectedProjectData) {
      // Crear objeto proyecto para localStorage manteniendo compatibilidad
      const projectForStorage = {
        id: selectedProjectData.id,
        nombre: selectedProjectData.nombre,
        tipo: "proyecto"
      };

      localStorage.setItem("selectedProject", JSON.stringify(projectForStorage));

      toast.success("Proyecto seleccionado correctamente, redireccionando...", {
        position: "bottom-right",
        autoClose: 1000,
      });

      const destino =
        location.state?.from || "/gestionar-turnos";

      // Redirigir al destino (p. ej. homologación) o al dashboard
      setTimeout(() => {
        navigate(destino, { replace: true });
      }, 1000);
    } else {
      toast.error("Por favor selecciona un proyecto válido", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  // Función legacy eliminada - ahora se usa handleLogin y handleProjectSelection

  return (
    <>
      {/* Paleta Digital Harmony para Login */}
      <style>
        {`
          /* Fondo degradado moderno */
          .login-bg {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            min-height: 100vh;
          }
          
          /* Card con efecto vidrio */
          .login-card {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 20px;
            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
          }
          
          /* Botón principal con Digital Harmony */
          .btn-dh-login {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 24px;
            font-weight: 600;
            font-size: 1.1rem;
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-login:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 12px 35px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-login:active {
            transform: translateY(0);
          }
          
          /* Botón secundario */
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 24px;
            font-weight: 600;
            font-size: 1.1rem;
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 12px 35px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          /* Campos de entrada modernos */
          .form-control-dh {
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }
          
          .form-control-dh:focus {
            border-color: #ff8c00;
            box-shadow: 0 0 0 0.2rem rgba(255, 140, 0, 0.25);
            background: white;
          }
          
          /* Títulos con gradiente */
          .title-gradient {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            font-weight: 700;
          }
          
          /* Labels modernos */
          .form-label-dh {
            color: #374151;
            font-weight: 600;
            font-size: 0.95rem;
            margin-bottom: 8px;
          }
          
          /* Texto de bienvenida */
          .welcome-text {
            color: #6b7280;
            font-size: 1rem;
            line-height: 1.5;
          }
        `}
      </style>
      
      <Container fluid className="d-flex align-items-center justify-content-center login-bg">
        <ToastContainer />
        <Row className="w-100 justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Card className="login-card border-0">
              <Card.Body className="p-5">
              {!showProjectSelection ? (
                // Pantalla de Login (Usuario y Contraseña)
                <>
                  <Card.Title className="text-center mb-4">
                    <h2 className="title-gradient">Iniciar Sesión</h2>
                  </Card.Title>
                  <Form onSubmit={handleLogin}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label-dh">Usuario</Form.Label>
                  <Form.Control
                    type="text"
                    value={user}
                    onChange={(e) => setUser(e.target.value)}
                    required
                    placeholder="Ingrese su usuario"
                    className="form-control-dh"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="form-label-dh">Contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="Ingrese su contraseña"
                    className="form-control-dh"
                  />
                </Form.Group>

                    <div className="d-grid gap-2">
                      <Button
                        type="submit"
                        size="lg"
                        className="btn-dh-login d-flex align-items-center justify-content-center gap-2"
                      >
                        <FaCheckCircle size={20} />
                        Iniciar Sesión
                      </Button>
                    </div>
                  </Form>
                </>
              ) : (
                // Pantalla de Selección de Proyecto
                <>
                  <Card.Title className="text-center mb-4">
                    <h2 className="title-gradient">Seleccionar Proyecto</h2>
                  </Card.Title>
                  <p className="text-center welcome-text mb-4">
                    Bienvenido, <strong>{JSON.parse(localStorage.getItem('user') || '{}').username || 'Usuario'}</strong>.
                    <br />
                    Selecciona un proyecto para continuar:
                  </p>
                  <Form onSubmit={handleProjectSelection}>
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label-dh">Proyecto</Form.Label>
                      <Form.Select
                        value={selectedProject}
                        onChange={(e) => setSelectedProject(e.target.value)}
                        required
                        className="form-control-dh"
                      >
                        <option value="" disabled>
                          Selecciona un proyecto
                        </option>
                        <option value="-1">
                          Corporativo
                        </option>
                        {projects.map((proyecto) => (
                          <option key={proyecto.id} value={proyecto.id}>
                            {proyecto.nombre}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <div className="d-grid gap-2">
                      <Button
                        type="submit"
                        size="lg"
                        className="btn-dh-login d-flex align-items-center justify-content-center gap-2"
                      >
                        <FaCheckCircle size={20} />
                        Continuar
                      </Button>
                      <Button
                        onClick={() => {
                          // Limpiar sesión y volver al login
                          localStorage.removeItem('token');
                          localStorage.removeItem('user');
                          setShowProjectSelection(false);
                          setUser('');
                          setPassword('');
                          setProjects([]);
                          setSelectedProject('');
                        }}
                        size="lg"
                        className="btn-dh-secondary"
                      >
                        Volver al Login
                      </Button>
                    </div>
                  </Form>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default Login;
